
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants } from '../../../constants/ebtq-constants';
import { ArrayOfKeys } from '../../../model/ArrayOfKeys';
import { LoanQuerySearchCriteria } from '../../../model/loanQuerySearchCriteria';
import { TransactionWrapper } from '../../../model/transactionWrapper';
import { ApiService } from '../../../services/api.service';
import { ErrorService } from '../../../shared/error-page/service/error-service';
import { UtilityService } from '../../../services/utility-service';
import {Title} from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-query-loans',
  templateUrl: './query-loans.component.html',
  styleUrls: ['./query-loans.component.scss']
})
export class QueryLoansComponent implements OnInit, OnDestroy {

  private errorSub: Subscription;
  header = true;
  errHeading: string;
  transactionWrapper: TransactionWrapper;
  loanQuerySearchCriteria: LoanQuerySearchCriteria;
  utilService: UtilityService;
  router: Router;
  purchaseDateStart: Date;
  purchaseDateEnd: Date;
  interestRateStart: string;
  interestRateEnd: string;
  fundingDateStart: Date;
  fundingDateEnd: Date;
  paymentPlan: any[];
  paymentStatus: any[];
  productType: any[];
  loanStatus: any[];
  PaymentStatus: any[];
  warningMessage = '';
  errorMessage: string[];
  containsError = false;
  errorMsg: string;
  queryLoanForm:  UntypedFormGroup;
  mainPage: string;
  fhaExt: any[];
  isExternal :boolean;
  serNumber: any[];
  title = 'Submit Loan Query';

  constructor(private apiService: ApiService, private errorService: ErrorService, router: Router,
              private titleService: Title, private cdr: ChangeDetectorRef) {

    this.router = router;
    this.utilService = new UtilityService();
    this.loanStatus = [];
    this.loanStatus = this.utilService.queryLoanStatus;

    this.paymentStatus = [];
    this.paymentStatus = this.utilService.schdPaymentStatus;

    this.paymentPlan = [];
    this.paymentPlan = this.utilService.queryLoanPaymentPln;

    this.productType = [];
    this.productType = this.utilService.productCode;

    this.fhaExt = [];
    this.fhaExt.push({label: '912', value: '912'});
    this.fhaExt.push({label: '952', value: '952'});

    this.queryLoanForm = new UntypedFormGroup({
      loanNumber: new UntypedFormControl(''),
      fhaCaseNumber: new UntypedFormControl(''),
      lenderLoanNumber: new UntypedFormControl(''),
      servicerNumber: new UntypedFormControl(''),
      loanStatus: new UntypedFormControl(''),
      paymentStatus: new UntypedFormControl(''),
      paymentPlan: new UntypedFormControl(''),
      productType: new UntypedFormControl(''),
      purchaseDateStart: new UntypedFormControl(''),
      purchaseDateEnd: new UntypedFormControl(''),
      fundingDateStart: new UntypedFormControl(''),
      fundingDateEnd: new UntypedFormControl(''),
      interestRateStart: new UntypedFormControl(''),
      interestRateEnd: new UntypedFormControl(''),
      loanBalanceStart: new UntypedFormControl(''),
      loanBalanceEnd: new UntypedFormControl('')
    });
  }

  validateInput() {
    let valid = true;

    if (this.queryLoanForm.value.loanNumber === '' && this.queryLoanForm.value.fhaCaseNumber === ''
      && this.queryLoanForm.value.lenderLoanNumber === ''
      && (this.queryLoanForm.value.servicerNumber === '' || this.queryLoanForm.value.servicerNumber === 'ALL')) {
      this.errorMessage = [Constants.QUERY_LOAN_ERR];
      valid = false;
    }
    else {
      this.errorMessage = [];
      if ((this.queryLoanForm.value.loanNumber !== '' && this.queryLoanForm.value.loanNumber[0] !== '6') ||
        (this.queryLoanForm.value.loanNumber !== '' && this.queryLoanForm.value.loanNumber.length !== 10)) {
        this.errorMessage.push(Constants.LOAN_NUM_ERR);
        valid = false;
      }
      if (this.queryLoanForm.value.servicerNumber !== '' && this.queryLoanForm.value.servicerNumber !== 'ALL' && this.queryLoanForm.value.servicerNumber.length !== 9) {
        this.errorMessage.push(Constants.SERV_NUM_ERR);
        valid = false;
      }

      if (this.queryLoanForm.value.fhaCaseNumber !== '' && this.queryLoanForm.value.fhaCaseNumber.length !== 10) {
        this.errorMessage.push(Constants.FCH_CASE_NUM_ERR);
        valid = false;
      }

      if (this.queryLoanForm.value.lenderLoanNumber !== '' && this.queryLoanForm.value.lenderLoanNumber.length > 15) {
        this.errorMessage.push(Constants.LENDERLOAN_VALIDATION);
        valid = false;
      }
    }

    return valid;
  }

  getLoansKeylist() {
    this.warningMessage = '';
    if (this.validateInput()) {

      let arrayOfkeys: ArrayOfKeys;
      this.transactionWrapper = new TransactionWrapper();
      this.loanQuerySearchCriteria = new LoanQuerySearchCriteria();
      this.transactionWrapper.queryServiceName = Constants.LOAN_QUERY_KEY_LIST;
      this.loanQuerySearchCriteria.loanNumber = this.queryLoanForm.value.loanNumber;
      this.loanQuerySearchCriteria.fhaCaseNumber = this.queryLoanForm.value.fhaCaseNumber;
      this.loanQuerySearchCriteria.lenderLoanNumber = this.queryLoanForm.value.lenderLoanNumber;
      if (this.queryLoanForm.value.loanStatus != null && this.queryLoanForm.value.loanStatus !== '') {
        this.loanQuerySearchCriteria.loanStatus = this.queryLoanForm.value.loanStatus;
      }
      if (this.queryLoanForm.value.paymentPlan != null && this.queryLoanForm.value.paymentPlan !== '') {
        this.loanQuerySearchCriteria.paymentPlan = this.queryLoanForm.value.paymentPlan;
      }
      if (this.queryLoanForm.value.fundingDateStart != null && this.queryLoanForm.value.fundingDateStart !== '') {
        this.loanQuerySearchCriteria.fundingDateStart = this.utilService.convertMillisecToDate(this.queryLoanForm.value.fundingDateStart);
      }
      if (this.queryLoanForm.value.fundingDateEnd != null && this.queryLoanForm.value.fundingDateEnd !== '') {
        this.loanQuerySearchCriteria.fundingDateEnd = this.utilService.convertMillisecToDate(this.queryLoanForm.value.fundingDateEnd);
      }
      if (this.queryLoanForm.value.purchaseDateEnd != null && this.queryLoanForm.value.purchaseDateEnd !== '') {
        this.loanQuerySearchCriteria.purchaseDateEnd = this.utilService.convertMillisecToDate(this.queryLoanForm.value.purchaseDateEnd);
      }
      if (this.queryLoanForm.value.purchaseDateStart != null && this.queryLoanForm.value.purchaseDateStart !== '') {
        this.loanQuerySearchCriteria.purchaseDateStart = this.utilService.convertMillisecToDate(this.queryLoanForm.value.purchaseDateStart);
      }
      this.loanQuerySearchCriteria.interestRateStart = this.queryLoanForm.value.interestRateStart;
      this.loanQuerySearchCriteria.interestRateEnd = this.queryLoanForm.value.interestRateEnd;
      this.loanQuerySearchCriteria.loanBalanceEnd = this.queryLoanForm.value.loanBalanceEnd;
      this.loanQuerySearchCriteria.loanBalanceStart = this.queryLoanForm.value.loanBalanceStart;
      if (this.queryLoanForm.value.paymentStatus != null && this.queryLoanForm.value.paymentStatus !== '') {
        this.loanQuerySearchCriteria.paymentStatus = this.queryLoanForm.value.paymentStatus;
      }
      if (this.queryLoanForm.value.productType != null && this.queryLoanForm.value.productType !== '') {
        this.loanQuerySearchCriteria.productType = this.queryLoanForm.value.productType;
      }
      if (this.queryLoanForm.value.servicerNumber !== '' && this.queryLoanForm.value.servicerNumber !== 'ALL') {
        this.loanQuerySearchCriteria.servicerNumberList = [this.queryLoanForm.value.servicerNumber];
      } else if (this.queryLoanForm.value.servicerNumber === 'ALL') {
        this.loanQuerySearchCriteria.servicerNumberList = [];
      }
      this.transactionWrapper.parameters[0] = this.loanQuerySearchCriteria;


      this.apiService.executeQuery(this.transactionWrapper).subscribe(
        (data: any) => {
          const values = [];
          // Obj is List of keys
          const obj = Object.values(data)[6];
          arrayOfkeys = new ArrayOfKeys();

          for (const [key, value] of Object.entries(obj)) {
            values[key] = value;
          }
          if (values.length === 0) {
            this.warningMessage = 'Your query returned no data.';
            this.queryLoanForm.value.loanNumber.nativeElement.focus();
            this.cdr.detectChanges();
            return;
          }
          if (data != null && data !== 0 && data.object != null &&  data.object !== 0 && data.object[0].hasOwnProperty('SRVR_NO')) {
            const srvrNo = data.object[0].SRVR_NO;
            if (!this.utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
              console.log('The service number doesnt belong to the logged in user');
              this.warningMessage = Constants.NO_DATA_MESSAGE;
              this.cdr.detectChanges();
              return;
            }
          }
          if (values.length > 500) {
            this.warningMessage = 'Your query will return over 500 records, please further define your query.';
            this.queryLoanForm.value.loanNumber.nativeElement.focus();
            this.cdr.detectChanges();
            return;
          }
          else {
            arrayOfkeys.keys = Array.from(values, function(map) {
              return map['FNM_LN_NO'];
            });
            this.mainPage = 'QueryLoan';
            /** Routing to result page when there are matching records. passing list of matching keys to get results */
            this.router.navigate(['queryLoansResult'], {

              queryParams: { query: btoa(JSON.stringify(arrayOfkeys.keys)), mainPage: this.mainPage }
            });
          }
        },

        error => {
          if (error != null && typeof error === 'string' && error.includes('504'))
          {
            this.warningMessage = Constants.QUERY_SEARCH_TAKING_LONG_WARNING;
            this.cdr.detectChanges();
            return;
          } else {
            this.errorService.announceError(error);
          }
        }
      );
      this.errorAnnouncement();
    }
  }
  errorAnnouncement() {
    // error announcement
    this.errorSub = this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.errorSub) {
      this.errorSub.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.serNumber = [];
    this.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.isExternal = (this.isExternal == null) ? false : this.isExternal;
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');

    if (this.isExternal) {
      if (sessionStorage.getItem('authServrList') != null) {
        const authServrList = Array.from(JSON.parse(sessionStorage.getItem('authServrList')));
        this.serNumber.push({label: 'ALL', value: 'ALL'});
        for (let i = 0; i < authServrList.length; i++) {
          this.serNumber.push(authServrList[i]);
        }
        this.queryLoanForm.controls['servicerNumber'].setValue(this.serNumber[0].value);
      }
    }

  }

  onClear(): void {
    this.queryLoanForm.reset();
  }


}
